
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/endorsement",
      function () {
        return require("private-next-pages/endorsement/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/endorsement"])
      });
    }
  